// extracted by mini-css-extract-plugin
module.exports = {"container":"coverImage_container__6c9xe","cover":"coverImage_cover__VbMwN","limited":"coverImage_limited__WgGO5","blurred":"coverImage_blurred____5Mt"};